export default __webpack_public_path__ + "static/camper-van-58fffa0dcad808300753005c5d22c4a0.jpg";